import clsx from 'clsx';
import React from 'react';

const defaultTileClasses = clsx(
  'relative flex flex-col justify-between',
  'text-left',
  'group/tile',
  'w-full',
  'aspect-[3/2]',
  'p-f1',
  'desktop:p-f2',
  'text-main-500'
);

export const tileGridClassName = clsx(
  'grid grid-cols-1 wideTablet:grid-cols-2 laptop:grid-cols-3 largeLaptop:grid-cols-4 gap-f1'
);

const Skeleton = () => (
  <div className={clsx(defaultTileClasses, 'border-main-300 border-[0.5px]')} />
);

export const TileComponent = ({
  children,
  onClick,
  onContextMenu,
  interactive = false,
  'data-testid': dataTestId,
}: {
  children?: React.ReactNode;
  onClick?: (evt: React.MouseEvent) => void;
  onContextMenu?: (evt: React.MouseEvent) => void;
  interactive?: boolean;
  'data-testid'?: string;
}) => {
  const className = clsx(
    defaultTileClasses,
    'bg-main-200 border-main-300 border-[0.5px]',
    (onClick || interactive) && 'hover:bg-negative cursor-pointer'
  );
  if (!onClick) {
    return (
      <div data-testid={dataTestId} className={className}>
        <div className="flex h-full w-full flex-col items-start">
          {children}
        </div>
      </div>
    );
  }
  return (
    <button
      type="button"
      data-testid={dataTestId}
      className={className}
      onContextMenu={onContextMenu}
      onClick={onClick}
    >
      <div className="flex h-full w-full flex-col items-start">{children}</div>
    </button>
  );
};

export const Tile = {
  Skeleton,
  Component: TileComponent,
};
